import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import { useContext } from "react";
// components
import { TEXT } from "../../../constants/text";
import { useResultsContext } from "../../../services/context/results-context";
import { useAppContext } from "../../../services/context/app-context";

// services
import MapContext from "../../../services/context/map-context";

// img
import { ReactComponent as ImgResultEmpty1 } from "../../../assets/img/result-empty-msg-1.svg";
import { ReactComponent as ImgResultEmpty2 } from "../../../assets/img/result-empty-msg-2.svg";
import { ReactComponent as IconGPS } from "../../../assets/svg/gps.svg";
import { PropertySection } from "./property-data";
import { useParams } from "react-router-dom";
import {
  DEV_OUTLINEs,
  DEV_PROJECT_IDs,
  PROD_OUTLINEs,
  PROD_PROJECT_IDs,
} from "../../../constants/global.constants";
import { TooltipCustom } from "../../ui/tooltip-custom";

export const SidebarResultsEmpty = ({}) => {
  const { projectId } = useParams();
  const { map, mapLoaded } = useContext(MapContext);
  const { property } = useAppContext();
  /*  const {runners, buildings} = useResultsContext();
  const {property} = useAppContext();

  console.log(runners, property, buildings, 'runners, property'); */

  const handleFlyToProperty = (propertyLocation) => {
    map.flyTo({ center: propertyLocation, zoom: 17 });
  };

  const PROJECT_IDs =
    process.env.NODE_ENV === "production" ? PROD_PROJECT_IDs : DEV_PROJECT_IDs;
  const OUTLINES =
    process.env.NODE_ENV === "production" ? PROD_OUTLINEs : DEV_OUTLINEs;

  return (
    <Box
      sx={{
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        alignItems: "center" /* 
            justifyContent: "center", */,
        flexGrow: 1,
        overflow: "auto",
      }}
    >
      {property ? <PropertySection propertyData={property} /> : null}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {projectId && PROJECT_IDs.includes(projectId)
          ? PROJECT_IDs.map((pid) => {
              if (projectId === pid) return null;
              const outline = OUTLINES[pid];
              const propertyLocation = outline.coordinates
                ? [
                    outline.coordinates?._longitude,
                    outline.coordinates?._latitude,
                  ]
                : null;

              return (
                <Box
                  key={pid}
                  sx={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PropertySection
                    propertyData={outline}
                    displayTitle={false}
                  />

                  <TooltipCustom
                    text={"Center to the property"}
                    placement="top"
                  >
                    <Box mb={"16px"}>
                      <Button
                        disabled={!propertyLocation}
                        onClick={() => handleFlyToProperty(propertyLocation)}
                        sx={{
                          minWidth: "24px",
                        }}
                      >
                        <IconGPS fill="#343745" width="24px" height="24px" />
                      </Button>
                    </Box>
                  </TooltipCustom>
                </Box>
              );
            })
          : null}
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
          /*   overflow: "auto", */
        }}
      >
        <ImgResultEmpty1 />

        <Typography
          sx={{
            fontSize: "14px",
            color: "#343745",
            textAlign: "center",
            span: { color: "#efa21e" },
          }}
        >
          {TEXT.sidebarResults.emptySearch.part1Start}{" "}
          <span>{TEXT.sidebarResults.emptySearch.part1Highlight}</span>{" "}
          {TEXT.sidebarResults.emptySearch.part1End}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#343745",
            textAlign: "center",
            span: { color: "#efa21e" },
          }}
        >
          {TEXT.sidebarResults.emptySearch.part2Start}{" "}
          <span>{TEXT.sidebarResults.emptySearch.part2Highlight}</span>
          {TEXT.sidebarResults.emptySearch.part2End}
        </Typography>
        <Typography
          sx={{
            fontSize: "14px",
            color: "#343745",
            textAlign: "center",
          }}
        >
          {TEXT.sidebarResults.emptySearch.part3}
        </Typography>
      </Box>
    </Box>
  );
};
